import React from 'react';
import TeamSection from '../components/settings/TeamSection';
export default function SettingsTeamPage() {
  return <TeamSection />;
}
